"use strict";



const _defaults = {
	items: '.carousel--item',
	
	autoPlay: true, 
	
	progressBar: {
		enabled: false,
		className: 'carousel--progress-bar',
	},
	
	durations: {
		standby: 9000,
		transition: 600,
	},
	
	item: {
		activeClassName: 'item--active',
		exitClassName: 'item--exit',
	},
	
	nav: {
		rootClassName: 'carousel--nav',
		holderClassName: 'ui-holder',
		menuClassName: 'bullets-nav-menu',
		menuItemClassName: 'menu-item',
		currentMenuItemClassName: 'current-menu-item',
		buttonClassName: 'bullets-nav-menu-item',
	},
};



/*
 *
 */
export default class Carousel {
	 
	#element;
	#items;
	#nav; 
	#progressBar;
	#options;
	
	#timerId = null;
	#interTimerId = null;
	#classNameTimerId = null;
	
	#index = null;
	
	/*
	 *
	 */
	constructor(element, options) {
		
		this.#options = Object.assign(_defaults, options);
		
		this.#element = element;
		if(! this.#element) {
			return;
		}
		
		this.#items = Array.from( this.#element.querySelectorAll(this.#options.items) );
		if( this.#items.length > 0 ) {
			this.initialize();
		}
	}

	
	/*
	 *
	 */
	initialize() {
		const _this = this;
		// nav 
		const total = this.#items.length;
		if( total > 1 ) {
			// create navigation
			this.#nav = new Navigation(total, this.#options.nav, (index) => _this.show(index) );
			const navElement = _this.#nav.getElement();
			this.#element.appendChild(navElement);
			
			// create progress bar
			if( this.#options.progressBar.enabled ) {
				this.#progressBar = new ProgressBar(this.#options.progressBar.className, this.#options.durations.standby);
				const progressBarElement = _this.#progressBar.getElement();
				this.#element.appendChild(progressBarElement);
			}
		}
		
		this.show(0);
	}



	
	
	/*
	 *
	 */
	show(index) {
		const _this = this;
		const { activeClassName, exitClassName } = this.#options.item;
		
		clearInterval(this.#timerId);
		clearInterval(this.#interTimerId);
		clearInterval(this.#classNameTimerId);
		
		if(! this.#items[index] || this.#items[index].classList.contains(activeClassName)) {
			return;
		}
		
		this.#items.forEach( (s, i) => {
			if(! s.classList.contains(activeClassName)) {
				return;
			}
			
			s.classList.remove(activeClassName);
			s.classList.add(exitClassName);
			
			_this.#progressBar && _this.#progressBar.reset();

			_this.#classNameTimerId = setInterval(() => {
				_this.#items.forEach( _s => _s.classList.remove(exitClassName) );
				clearInterval(_this.#classNameTimerId);
			}, _this.#options.durations.transition);
		});

		this.#index = index;

		this.#interTimerId = setInterval(() => {
			clearInterval(_this.#interTimerId);
			_this.#nav && this.#nav.setActive(_this.#index);
			_this.#items[index].classList.add(activeClassName);
			_this.resume();
		}, _this.#options.durations.transition);
	}
	

	
	/*
	 *
	 */
	resume() {
		const _this = this;
		this.#progressBar && this.#progressBar.play();
		this.#timerId = setInterval(() => _this.next(), this.#options.durations.standby);
	}

	
	/*
	 *
	 */
	next() {
		if(! this.#options.autoPlay ) {
			return;
		}
		
		if( this.#index === this.#items.length - 1 ) {
			return this.show(0);
		}
		this.show(this.#index + 1);
	}
}



/*
 *
 */
class Navigation {
	#total;
	#options;
	#element;
	#onItemClick;
	
	constructor(total, options, onItemClick = null) {
		this.#total = total;
		this.#onItemClick = onItemClick;
		this.#options = options;
		this.init();
	}
	
	init() {
		const _this = this;
		const options = this.#options;
		const nav = document.createElement('nav');
		nav.classList.add(options.rootClassName);
		
		const holder = document.createElement('div');
		holder.classList.add(options.holderClassName);
		
		const ul = document.createElement('ul');
		ul.classList.add('menu', options.menuClassName);
		
		for( let i = 0; i < this.#total; i++ ) {
			const b = document.createElement('button'),
				li = document.createElement('li');
			
			li.classList.add(options.menuItemClassName);
		
			b.setAttribute('data-slide', i);
			b.classList.add(options.buttonClassName, `${options.buttonClassName}-${i}`);
			b.addEventListener('click', event => {
				event.preventDefault();
				const index = parseInt(event.currentTarget.dataset.slide, 10);
				_this.#onItemClick && _this.#onItemClick(index);
			});
			
			li.appendChild(b);
			ul.appendChild(li);
		}
		
		holder.appendChild(ul);
		nav.appendChild(holder);
		
		this.#element = nav;
	}
	
	
	setActive(index) {
		const options = this.#options;
		const bullets = Array.from( this.#element.querySelectorAll(`.${options.currentMenuItemClassName}`) );
		bullets.forEach(b => b.classList.remove(options.currentMenuItemClassName));
		
		const navItems = Array.from( this.#element.querySelectorAll(`.${options.menuItemClassName}`) );
		if( navItems[index] ) {
			navItems[index].classList.add(options.currentMenuItemClassName);
		}
	}
	
	
	getElement() {
		return this.#element;
	}
}



class ProgressBar {
	
	#element;
	#className;
	#duration;
	
	constructor(className, duration) {
		this.#className = className;
		this.#duration = duration;
		this.init();
	}
	
	init() {
		this.#element = document.createElement('div');
		this.#element.classList.add(this.#className);
	}
	
	play() {
		this.#element.style.transition = `width ${this.#duration}ms linear`;
		this.#element.style.width = '100%';
	}
	
	reset() {
		this.#element.style.transition = '0ms';
		this.#element.style.width = 0;
	}
	
	getElement() {
		return this.#element;
	}
}